import React, { useState, useEffect, useContext } from "react";
import {
	List,
	Space,
	Skeleton,
	Button,
	Drawer,
	message,
	Input,
	Checkbox,
	Tooltip,
	Modal,
	Select,
	Row,
	Col,
	Divider,
	Table,
	Badge,
	InputNumber,
	theme
} from "antd";
import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import { 
	reload_nomenclature, 
	edit_company, 
	// get_company_by_nit_for_entity 
} from "../services";
import { useCalculateListSizeForPaginationHook } from "../hooks";
import { reduceText } from "../utils/Formaters";

import PropTypes from "prop-types";
import { Contacts } from "../components/entities/components/Contacts";
import { hover_item } from "../hover";
import { CompaniesContext } from "../contexts";
// import { isObjectEmpty } from "../utils/ObjectOperators";

const no_selected_company = {
	id: "",
	address: "",
	country: "",
	description: "",
	is_associated_company: true,
	name: "",
	plan: "",
	accounting_resources: {
		accounting_plan: [],
		diaries: [],
		expense_accounts: [],
		sale_accounts: [],
		others:{
			analytic_accounts:[]
		}
	},
	database_id: "",
	tax_authority_specifications: {
		agente_retenedor_iva: false,
		establishments: [],
		isr_regimen: "",
		iva_regimen: ""
	},
	email_emition_specifications: {
		email: "",
		password: "",
		host: ""
	},
	looker_link: "",
	database: null,
	type_tid: "",
};

const { TextArea } = Input;

// const no_new_company =  {
// 	name: "",
// 	tid: "",
// 	type_tid: "",
// };

const no_new_establishment = {
	id: 0,
	name: "",
	state: true
};

export const CompaniesUser = ({ token }) => {

	const {token: antToken} = theme.useToken();

	const { companies, updateCompaniesIncludingLocalStorage } = useContext(CompaniesContext);
	
	const [loading, setLoading] = useState(true);
	// const [loadingCreateCompany, setLoadingCreateCompany] = useState(false);
	const [loadingSubmit, setLoadingSubmit] = useState(false);
	const [nomenclatureLoading, setNomenclatureLoading] = useState(false);

	const [open, setOpen] = useState(false);
	const [openCreateEsablishment, setOpenCreateEstablishment] = useState(false);
	const [openEditEsablishment, setOpenEditEstablishment] = useState(false);
	const placement = "right";
	const { pageSize } = useCalculateListSizeForPaginationHook(40);

	const [companiesTable, setCompaniesTable] = useState([]);
	const [selected, setSelected] = useState(no_selected_company);
	// const [selectedKeysExpenses, setSelectedKeysExpenses] = useState([]);
	// const [selectedKeysSales, setSelectedKeysSales] = useState([]);

	const [establishment, setEstablishment] = useState(no_new_establishment);

	// const [openCreate, setOpenCreate] = useState(false);
	// const [openConsultCompany, setOpenConsultCompany] = useState(false);

	const [hoveredItem, setHoveredItem] = useState(null);

	// const [newCompany, setNewCompany] = useState(no_new_company);
	// const newCompany = no_new_company;

	const stablishment_columns = [
		{
			title: "Nombre",
			dataIndex: "name",
			showSorterTooltip: {
				target: "full-header",
			},
			width: 300,
			sorter: (a, b) => a.name.length - b.name.length,
			sortDirections: ["descend"],
		},
		{
			title: "Código",
			dataIndex: "id",
			defaultSortOrder: "descend",
			width: 150,
			sorter: (a, b) => a.age - b.age,
		},
		{
			title: "Estado",
			dataIndex: "state",
			width: 150,
			filters: [
				{
					text: "Activo",
					value: true,
				},
				{
					text: "Inactivo",
					value: false,
				},
			],
			onFilter: (value, record) => record.state === value,
			render: (value) => <Badge status={value? "success" : "default"} text={value? "Activo" : "Inactivo"} />,
		},
		{
			title: "Edición",
			key: "edit",
			render: (value) => <a onClick={() => showEditEstablishment(value)}>Editar</a>
		},
		{
			title: "Activación",
			key: "activate",
			render: (value) => ( value.state? 
				<a onClick={() => {handleToggleActivationEstablishment(value);}}>Desactivar</a> : 
				<a onClick={() => {handleToggleActivationEstablishment(value);}}>Activar</a>
			)
		}
	];
	

	/* CREATE COMPANY */

	// const showCreateCompanyModal = () => {
	// 	setOpenCreate(true);
	// };

	// const cancelCreateCompany = () => {
	// 	setOpenCreate(false);
	// };

	/* COMPONENT VARIABLES */

	const showEdit = () => {
		setOpen(true);
	};
	const onClose = () => {
		setOpen(false);
		setSelected(no_selected_company);
	};
	const showCreateEstablishment = () => {
		setOpenCreateEstablishment(true);
	};
	const onCloseCreateEstablishment = () => {
		setOpenCreateEstablishment(false);
	};
	const showEditEstablishment = (value) => {
		setEstablishment(value);
		setOpenEditEstablishment(true);
	};
	const onCloseEditEstablishment = () => {
		setEstablishment(no_new_establishment);
		setOpenEditEstablishment(false);
	};

	const handleReloadNomenclature = async () => {
		setNomenclatureLoading(true);

		try {
			const resReload = await reload_nomenclature(token, selected.id);

			if (resReload) {
				message.success(
					"Recarga de nomenclatura en proceso, los cambios pueden tardar hasta 1 minuto."
				);
			}
		} catch (error) {
			message.error("Ha ocurrido un error");
		} finally {
			setNomenclatureLoading(false);
		}
	};

	/* SEARCH COMPANY */

	useEffect(() => {
		setCompaniesTable(companies);
		setLoading(false);
	}, []);

	const onChangeSearch = (value) => {
		const text = value.target.value;

		const matchesText = (str) => {
			if (typeof str === "string") {
				return str.toLowerCase().includes(text.toLowerCase());
			}
			else if (typeof str === "number") {
				return String(str).toLowerCase().includes(text.toLowerCase());
			}
			return false;
		};

		const checkObjectForMatch = (obj) => {
			for (const key in obj) {
				if (matchesText(obj[key])) {
					return true;
				}

				if (typeof obj[key] === "object" && obj[key] !== null) {
					if (checkObjectForMatch(obj[key])) {
						return true;
					}
				}
			}
			return false;
		};

		if (text === "") {
			setCompaniesTable(companies);
		} else {
			const resultado = companies.filter((company) =>
				checkObjectForMatch(company)
			);
			setCompaniesTable(resultado);
		}
	};

	/* EDITING COMPANY PROPERTIES */

	const updateSelected = (path, value) => {
		const newSelected = { ...selected };

		const keys = path.split(".");
		let current = newSelected;

		for (let i = 0; i < keys.length - 1; i++) {
			current = current[keys[i]] = { ...current[keys[i]] };
		}

		current[keys[keys.length - 1]] = value;
		setSelected(newSelected);
	};

	const handleCreateEstablishment = () => {
		// Asegurarnos de que 'establishments' exista como un array
		const establishments = selected.tax_authority_specifications.establishments || [];

		// Verificar si ya existe un establecimiento con el mismo id
		const found_establishment = establishments.find(company_establishment => company_establishment.id === establishment.id);

		if (found_establishment) {
			message.error("Un establecimiento con ese código ya existe");
		} else if (establishment.id < 1) {
			message.error("Código incorrecto");
		} else {
			// Crear una copia de 'selected' y su array 'establishments'
			const new_selected = {
				...selected,
				tax_authority_specifications: {
					...selected.tax_authority_specifications,
					establishments: [...establishments, establishment] // Añadir el nuevo establecimiento al array
				}
			};
		
			// Actualizar el estado con la nueva referencia
			setSelected(new_selected);
			setEstablishment(no_new_establishment);
			onCloseCreateEstablishment();
			message.info("Para guardar los cambios selecciona \"Modificar\"");
		}
	};
  

	const handleEditEstablishment = () => {
		// Crear una copia de 'establishments' con el establecimiento modificado
		const new_establishments = selected.tax_authority_specifications.establishments.map(company_establishment =>
			company_establishment.id === establishment.id 
				? { ...company_establishment, name: establishment.name } // Modificar el nombre del establecimiento
				: company_establishment
		);

		// Crear una nueva copia de 'selected' con el array de 'establishments' actualizado
		const new_selected = {
			...selected,
			tax_authority_specifications: {
				...selected.tax_authority_specifications,
				establishments: new_establishments
			}
		};

		// Actualizar el estado con el nuevo 'selected'
		setSelected(new_selected);

		// Resetear el formulario o los valores del establecimiento si es necesario
		setEstablishment(no_new_establishment);

		// Cerrar el diálogo o la ventana de edición
		onCloseEditEstablishment();

		// Mostrar el mensaje de información
		message.info("Para guardar los cambios selecciona \"Modificar\"");
	};

	const handleToggleActivationEstablishment = (establishment) => {
		// Crear una copia de 'establishments' con el estado del establecimiento invertido
		const new_establishments = selected.tax_authority_specifications.establishments.map(company_establishment =>
			company_establishment.id === establishment.id
				? { ...company_establishment, state: !company_establishment.state } // Invertir el estado
				: company_establishment
		);
	
		// Crear una nueva copia de 'selected' con el array de 'establishments' actualizado
		const new_selected = {
			...selected,
			tax_authority_specifications: {
				...selected.tax_authority_specifications,
				establishments: new_establishments
			}
		};

		// Actualizar el estado con el nuevo 'selected'
		setSelected(new_selected);

		// Resetear el formulario o los valores del establecimiento si es necesario
		setEstablishment(no_new_establishment);

		// Cerrar el diálogo o la ventana de edición
		onCloseEditEstablishment();

		// Mostrar el mensaje de información
		message.info("Para guardar los cambios selecciona \"Modificar\"");
	};

	// Usage:
	//const handleChangeName = (value) => updateSelected("name", value);
	// const handleChangeLookerLink = (value) => updateSelected("looker_link", value);
	const handleChangeAddress = (value) => updateSelected("address", value);
	const handleChangeDescription = (value) => updateSelected("description", value);
	const handleChangeCountry = (value) => updateSelected("country", value);
	// const handleChangeClient = (value) => updateSelected("is_associated_company", value);
	// const handleChangePlan = (value) => updateSelected("plan", value);

	const handleChangeTaxAuthoritySpecifications = (key, value) => {
		var new_tas = selected.tax_authority_specifications;
		new_tas[key] = value;
		updateSelected("tax_authority_specifications", new_tas);
	};

	const handleChangeEstablishmentName = (value) => {
		setEstablishment({
			...establishment,
			name: value
		});
	};
	
	const handleChangeEstablishmentId = (value) => {
		setEstablishment({
			...establishment,
			id: value
		});
	};

	/* SUBMIT COMPANY */

	const update_table = (companies) => {
		const index = companies.findIndex(company => company.id === selected.id);
		if (index !== -1) {
			companies[index] = {
				...selected,
				invoice_emition_specifications: {
					instructions: selected.invoice_emition_specifications.instructions,
					api_key:"",
					certifier: companies[index].invoice_emition_specifications?.certifier ?? "grupocds",
				}
			};
		}
		return companies;
	};

	const handleSubmit = async () => {
		if(!selected?.type_tid || selected?.type_tid?.trim() === ""){
			message.warning("Porfavor selecciona un tipo de nit.");
			return;
		}
		
		setLoadingSubmit(true);
		setLoading(true);

		const data = {
			id: selected.id,
			address: selected.address,
			country: selected.country,
			description: selected.description,
			tax_authority_specifications: {
				establishments: selected.tax_authority_specifications?.establishments || [],
				agente_retenedor_iva: selected.tax_authority_specifications?.agente_retenedor_iva || false,
				tax_free: selected.tax_authority_specifications?.tax_free || false,
				iva_regimen: selected.tax_authority_specifications?.iva_regimen || "",
				isr_regimen: selected.tax_authority_specifications?.isr_regimen || "",
			},
			contacts: selected?.contacts || [],
		};
		const res = await edit_company(token, data, "simple");
		if (res) {
			message.success(res);
			setCompaniesTable(update_table(companiesTable));			
			updateCompaniesIncludingLocalStorage(update_table(companies));
			onClose();
		}
		
		setLoading(false);
		setLoadingSubmit(false);		
	};
	
	return (
		<>
			<Skeleton avatar loading={loading} active>
				<Row>
					<Col
						span={12}
					/>
					<Col
						span={12}
					>
						<Input
							placeholder="Palabra Clave"
							style={{
								width:"90%",
							}}
							onChange={onChangeSearch}
							prefix={
								<SearchOutlined />
							}
						/>

					</Col>
				</Row>
				<List
					pagination={{
						position: "top",
						align: "center",
						disabled: false,
						showSizeChanger: false,
						pageSize: pageSize,
						showTotal:(total, range) => `${range[0]}-${range[1]} de ${total} Compañías`
					}}
					style={{
						textAlign: "start",
					}}
					size="small"
					dataSource={companiesTable}
					header={
						<Row
							style={{
								background: antToken.colorBgLayout,
								borderRadius:"10px"
							}}
						>
							<Col flex="auto">
								<List.Item key={0} >
									<List.Item.Meta 
										title="Nombre"
									/>
									<List.Item.Meta 
										style={{
											textAlign:"right",
										}} 
										title="NIT" 
									/>
								</List.Item>
							</Col>
						</Row>
					}
					renderItem={(item, index) => (
						<List.Item
							key={index}
							onMouseEnter={() => setHoveredItem(index)}
							onMouseLeave={() => setHoveredItem(null)}
							onClick={() => {
								showEdit();
								setSelected(item);
							}}
							style={hover_item(hoveredItem === index, antToken, "invoices", 45)}
						>
							<List.Item.Meta
								description={<p style={{ color:  antToken.colorText }}>{reduceText(item.name, 60)}</p>}
								style={{
									fontWeight: hoveredItem === index ? 600 : 400,
								}}
							/>
							<div>{item.tid}</div>
						</List.Item>
					)}
				/>
			</Skeleton>

			<Drawer
				title="Editar Empresa"
				placement={placement}
				width={1000}
				onClose={onClose}
				open={open}
				extra={
					<Space>
						<Button
							onClick={() => {
								onClose();
								setSelected(no_selected_company);
							}}
						>
							Cancelar
						</Button>
						<Button
							type="primary"
							loading={loadingSubmit}
							onClick={handleSubmit}
						>
							Modificar
						</Button>
					</Space>
				}
			>
				<Row gutter={[48, 8]}>
					<Divider>Configuraciones Generales</Divider>
					<Col span={12} > 
						<h3>Nombre: </h3>
						<p>{selected.name}</p>
					</Col>
					<Col span={3} >
						<h3>Nit: </h3>
						<p>{selected.tid}</p>
					</Col>
					<Col span={12} >
						<h3>Dirección: </h3>
						<TextArea
							rows={4}
							showCount
							maxLength={150}
							value={selected.address}
							onChange={(e) => handleChangeAddress(e.target.value)}
						/>
					</Col>
					<Col span={12} >
						<h3>Descripción: </h3>
						<TextArea
							rows={5}
							showCount
							maxLength={300}
							value={selected.description}
							onChange={(e) => handleChangeDescription(e.target.value)}
						/>
					</Col>
					<Col span={12} >
						<h3>País: </h3>
						<Input
							showCount
							maxLength={5}
							value={selected.country}
							onChange={(e) => handleChangeCountry(e.target.value)}
						/>
					</Col>
					<Divider>Especificaciones de Emisión de Correos Electrónicos</Divider>
					<Col span={24}>
						<h3>Contáctos: </h3>			
						<Contacts
							contacts={selected.contacts ? selected.contacts : []}
							onChangeContacts={value => setSelected({...selected, contacts: value})}
						/>
					</Col>
					<Divider>Especificaciones de la Autoridad Tributaria</Divider>
					<Col span={8} >
						<h3>Régimen IVA: </h3>
						<Select
							style={
								{
									width:"100%"
								}
							}
							showSearch
							placeholder="Selecciona un Régimen IVA"
							value={selected?.tax_authority_specifications?.iva_regimen? selected?.tax_authority_specifications?.iva_regimen: ""}
							onChange={(e) => handleChangeTaxAuthoritySpecifications( "iva_regimen" , e)}
							options={[
								{
									value: "GEN",
									label: "General",
								},
								{
									value: "EXE",
									label: "Exento",
								},
								{
									value: "PEQ",
									label: "Pequeño Contribuyente",
								},
								{
									value: "PEE",
									label: "Pequeño Contribuyente Electrónico",
								},
								{
									value: "AGR",
									label: "Agropecuario",
								},
								{
									value: "AGE",
									label: "Agropecuario Electrónico",
								},
							]}
						/>
					</Col>
					<Col span={8} >
						<h3>Régimen ISR: </h3>
						<Select
							style={
								{
									width:"100%"
								}
							}
							showSearch
							placeholder="Selecciona un Régimen ISR"
							value={selected.tax_authority_specifications.isr_regimen? selected.tax_authority_specifications.isr_regimen: ""}
							onChange={(e) => handleChangeTaxAuthoritySpecifications( "isr_regimen" , e)}
							options={[
								{
									value: "NAPL",
									label: "No aplica",
								},
								{
									value: "RSUAL",
									label: "Trimestral (Sobre Utilidades)",
								},
								{
									value: "ROSIAL",
									label: "Mensual (Opcional Simplificado)",
								}
							]}
						/>
					</Col>
					<Col span={8} >
						<h3>Agente Retenedor de IVA:</h3>
						<Checkbox
							checked={
								selected.tax_authority_specifications.agente_retenedor_iva? selected.tax_authority_specifications.agente_retenedor_iva: false
							}
							onChange={(e) => handleChangeTaxAuthoritySpecifications( "agente_retenedor_iva" , e.target.checked)}
						/>
					</Col>
					<Col span={24} >
						<h3>Establecimientos:</h3>
						<Table
							columns={stablishment_columns}
							dataSource={selected.tax_authority_specifications.establishments}
							showSorterTooltip={{
								target: "sorter-icon",
							}}
							footer={() =>
								<Button
									onClick={showCreateEstablishment}
								>Agregar</Button>
							}
						/>
					</Col>
				</Row>
				<Divider>Configuraciones de Funcionamiento</Divider>
				<Tooltip title="Recargar">
					<Button
						loading={nomenclatureLoading}
						type="primary"
						shape="circle"
						icon={<ReloadOutlined />}
						onClick={() => {
							handleReloadNomenclature();
						}}
					/>
				</Tooltip>
			</Drawer>
			<Modal
				title="Crear Establecimiento"
				open={openCreateEsablishment}
				onCancel={onCloseCreateEstablishment}
				footer={
					<Button
						type="primary"
						onClick={handleCreateEstablishment}
					>
						Crear
					</Button>
				}
			>
				<h3>Nombre</h3>
				<Input 
					value={establishment.name} 
					onChange={(e) => handleChangeEstablishmentName(e.target.value)}/>
				<h3>Código</h3>
				<InputNumber 
					min={1} 
					max={1000} 
					value={establishment.id} 
					onChange={handleChangeEstablishmentId} 
					controls={false}
				/>
			</Modal>
			<Modal
				title="Editar Establecimiento"
				open={openEditEsablishment}
				onCancel={onCloseEditEstablishment}
				footer={
					<Button
						type="primary"
						onClick={handleEditEstablishment}
					>
						Editar
					</Button>
				}
			>
				<h3>Nombre</h3>
				<Input 
					value={establishment.name} 
					onChange={(e) => handleChangeEstablishmentName(e.target.value)}/>
			</Modal>
		</>
	);
};

CompaniesUser.propTypes = {
	token: PropTypes.string.isRequired,
	companies: PropTypes.array.isRequired,
	setCompanies: PropTypes.func.isRequired,
};
